import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Clock, CheckCircle2, RotateCcw, Mail } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export default function BorrowManager({ books }) {
  const [invites, setInvites] = useState([]);

  const reload = useCallback(() => {
    api.get("/borrow/invites").then((r) => setInvites(r.data));
  }, []);
  useEffect(() => { reload(); }, [reload]);

  const forceReturn = async (id) => {
    await api.post(`/borrow/return/${id}`);
    toast.success("Book returned to your library");
    reload();
  };

  const fmt = (d) => (d ? new Date(d).toLocaleDateString() : "—");

  return (
    <div>
      <p className="text-sm text-slate-500 mb-4">
        Lend any book from its menu. Borrowers get an invite link to create an account; the book appears in their
        library and is auto-returned to you when the loan ends.
      </p>
      {invites.length === 0 ? (
        <p className="text-sm text-slate-400 py-8 text-center">No loans yet. Use a book's menu → "Lend this book".</p>
      ) : (
        <div className="space-y-2">
          {invites.map((inv) => (
            <div key={inv.id} data-testid="borrow-item"
              className="flex items-center gap-3 p-3 rounded-lg border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold truncate">{inv.book_title}</p>
                <p className="text-xs text-slate-500 flex items-center gap-1">
                  <Mail className="h-3 w-3" /> {inv.invite_email}
                  {inv.borrower_name && ` · ${inv.borrower_name}`}
                </p>
              </div>
              <div className="text-right text-xs text-slate-500">
                <div>{inv.weeks} weeks</div>
                {inv.due_date && <div>due {fmt(inv.due_date)}</div>}
              </div>
              {inv.status === "pending" && <Badge variant="secondary"><Clock className="h-3 w-3 mr-1" />Pending</Badge>}
              {inv.status === "active" && (
                <>
                  <Badge className="bg-emerald-600"><CheckCircle2 className="h-3 w-3 mr-1" />Borrowed</Badge>
                  <Button data-testid="force-return" size="sm" variant="outline" onClick={() => forceReturn(inv.id)}>
                    <RotateCcw className="h-3.5 w-3.5 mr-1" />Return
                  </Button>
                </>
              )}
              {inv.status === "returned" && <Badge variant="outline">Returned</Badge>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
